import _ from 'lodash'
import ObjectBooking from 'utils/objects/booking'
import { AppRoutes } from 'navigations/app-routes'
import HelperDate from 'utils/helper-date'
import HelperString from 'utils/helper-string'

const HelperTimeslotKinds = {
	
	isCustom: ( timeslotKind ) => {
		return _.startsWith( timeslotKind?.sub_kind ?? '', 'custom_' )
	},
	
	extractUntilTime: ( until, timeslotCapacityTime = null ) => {
		if( until === null ) {
			return null;
		}
		
		// This is the 'original' way of getting the values
		const [ unit, amount, by ] = until.split(':');
		
		const original = [ unit, amount, by ].join(':');
		
		// Add or subtract?
		const by1 = !HelperString.isEmptyString( by ) ? by : '-'
		
		// Extract the time from the string
		const timeString = until.split( original + ':' )[1]
		
		// Now pluck the time from the string
		const [ time1, time2 ] = timeString?.split(']:[') ?? [ '', '' ]
		
		// Clean the time
		const time1Clean = HelperTimeslotKinds._cleanTime( _.replace( time1, '[', '' ) )
		const time2Clean = HelperTimeslotKinds._cleanTime( _.replace( time2, ']', '' ) )
		
		return {
			unit,
			amount: parseInt( amount ),
			by: by1,
			fn: by1 === '+' ? 'add' : 'subtract',
			// Check if the timeslotCapacityTime is set and use that instead of the 'original' time
			timeFrom: timeslotCapacityTime !== null && !HelperString.isEmptyString( timeslotCapacityTime ) ? timeslotCapacityTime : time1Clean,
			original: {
				unit,
				amount,
				by,
				key: original,
				time1: time1Clean,
				time2: time2Clean,
				timeslotCapacityTime: timeslotCapacityTime
			}
		}
	},
	
	_cleanTime: ( time ) => {
		// If the time is null, return null
		if( time === 'null' || time === null ) {
			return null;
		}
		
		// If the time is empty, return null
		if( HelperString.isEmptyString( time ) ) {
			return null;
		}
		
		// Check if it is actually a time
		if( !time.includes(':') ) {
			return null;
		}
		
		return time;
	},
	
	getDateFromExtract: ( date, extract ) => {
		const { unit, amount, fn } = extract;
		
		let newDate = date.clone();
		if( fn === 'add' ) {
			newDate = newDate.add( amount, unit );
		} else {
			newDate = newDate.subtract( amount, unit );
		}
		
		// After the add or subtract, we set the date
		if( extract.timeFrom ) {
			const [ hour, minute ] = extract.timeFrom.split(':');
			
			newDate = newDate.set('hour', hour);
			newDate = newDate.set('minute', minute);
		}
		
		return newDate;
	},
	
	createDate: ( booking, time, timeslotCapacityTime ) => {
		// Check the start time
		const bookingStart = ObjectBooking.timeslotStart( booking );
		
		// Extract and check
		const extract = HelperTimeslotKinds.extractUntilTime( time, timeslotCapacityTime );
		
		return {
			date: HelperTimeslotKinds.getDateFromExtract( bookingStart, extract ),
			extract: extract
		};
	},
	
	canCancel: ( booking, time, timeslotCapacity ) => {
		const now = HelperDate.date();
		
		// Check if the current time is after the timeslot end time
		const timeslotEnd = ObjectBooking.timeslotEnd( booking );
		if( now.isAfter( timeslotEnd ) ) {
			return {
				can: false,
				date: null,
				extract: {}
			};
		}
		
		// Always? Always true :)
		if( time === 'always' ) {
			return {
				can: true,
				date: null,
				extract: {}
			};
		}
		
		// Check the start time
		const { date, extract } = HelperTimeslotKinds.createDate( booking, time, timeslotCapacity?.timeslot_can_cancel_until )
		
		return {
			can: date.isAfter( now ),
			date: date,
			extract: extract
		};
	},
	
	canBookByUntil: ( booking, time, timeslotCapacity ) => {
		const now = HelperDate.date()
		
		// Check if the current time is after the timeslot end time
		const timeslotEnd = ObjectBooking.timeslotEnd( booking );
		if( now.isSameOrAfter( timeslotEnd ) ) {
			return {
				can: false,
				date: null,
				extract: {}
			};
		}
		
		// Always? Always true :)
		if( time === 'always' ) {
			return {
				can: true,
				date: null,
				extract: {}
			};
		}
		
		// Check the start time
		const { date, extract } = HelperTimeslotKinds.createDate( booking, time, timeslotCapacity?.timeslot_can_book_until )
		
		return {
			can: date.isAfter( now ),
			date: date,
			extract: extract
		};
	},
	
	canBookByFrom: ( booking, time, timeslotCapacity ) => {
		const now = HelperDate.date()
		// Always? Always true :)
		if( time === 'always' ) {
			return {
				can: true,
				date: null,
				extract: {}
			};
		}
		
		// Check the start time
		const { date, extract } = HelperTimeslotKinds.createDate( booking, time, timeslotCapacity?.timeslot_can_book_from )
		
		return {
			can: date.isBefore( now ),
			date: date,
			extract: extract
		};
	},
	
	managementRouteName: ( timeslotKind ) => {
		return AppRoutes.MANAGEMENT_BOOKINGS_BOOKING +'_'+ timeslotKind.guid;
	}
}

export default HelperTimeslotKinds
